var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.991l-3.491-3.49a1.25 1.25 0 00-1.768-.001l-2.058 2.058-7.317 7.317a1.242 1.242 0 00-.366.884v3.491a1.251 1.251 0 001.25 1.25h3.491a1.24 1.24 0 00.884-.366L17.5 7.759a1.251 1.251 0 000-1.768zm-2.5 2.5l-3.491-3.49 1.616-1.617 3.491 3.491L15 8.491z",
    fill: "#33647E"
  })));
}
export default SvgPencil;